export default function getVersionFields(getValues, keys, before, after) {
	const beforeValues = getValues(before);
	const afterValues = getValues(after);

	return keys.map((key) => {
		const { value } = afterValues[key];
		const highlighted = (beforeValues[key].value || null) !== (value || null);

		return {
			key,
			...afterValues[key],
			highlighted,
			removed: highlighted && !value,
		};
	});
}
